import { mapState } from "vuex";

//- 銷售通路 Modal
import SalesChannelModalComponent from "@/components/SalesChannelModal/SalesChannelModal.vue";

export default {
    name: "SaleProductIndex",
    components: {
        SalesChannelModalComponent
    },
    data() {
        return {
            //- 目前選擇的商品型態項目
            nowSelectIndex: null,
            //- 商品分類
            itemBranch: null,
            //- 目前選擇的商品分類
            nowSelectItemBranch: null,
            //- 是否顯示詳細通路 Modal
            isSalesChannelModalShow: false,
            //- 銷售通路的資料
            salesChannelInfo: null,
            //- 要查看的銷售懶人包的銀行
            target_sale_product_bank: null
        };
    },
    mounted() {
        let vm = this;
        // 這邊另外帶入提示, 這樣可以確定 API 打完才關提示
        vm.$Swal.fire({
            title: "資料載入中, 請稍候",
            heightAuto: false,
            allowOutsideClick: false,
            onOpen: function onOpen() {
                vm.$Swal.showLoading();
            }
        });
        //- showRequestLoadingSwal 設定為 false, 防止 Swal 跳兩次
        window.showRequestLoadingSwal = false;
        vm.$store.dispatch("index/getMemberProfile").then(() => {
            vm.$store.dispatch("sale_product/index").then(() => {
                //- 設定預設第一層資訊
                vm.setDefaultInfo();
            });
        });
    },
    methods: {
        //- 計算最上方寬度
        calculationWidth: function() {
            let vm = this;
            if (vm.itemList && vm.itemList !== null && vm.itemList !== "") {
                if (vm.itemList.length <= 3) {
                    return `width: calc( ( 100% / 3 - 7px ) )`;
                } else {
                    return `width: calc( ( 100% / 3.5 - 7px ) )`;
                }
            } else {
                return;
            }
        },
        //- 選擇最上方項目
        selectItemHandler: function(item, index) {
            let vm = this;
            //- 重新設定商品詳細內容
            vm.$store.commit("sale_product/resetGoodsInfo");
            //- 清空選擇的商品型態
            vm.itemBranch = null;
            //- 清空選擇的商品分類
            vm.nowSelectItemBranch = null;
            //- 帶入目前選擇第幾個
            vm.nowSelectIndex = index;
            //- 帶入商品分類
            vm.itemBranch = item.sale_product_categories;
        },
        //- 選擇商品分類
        selectItemBranchHandler: function(item, index) {
            let vm = this;
            //- 重新設定商品詳細內容
            vm.$store.commit("sale_product/resetGoodsInfo");
            let data = {
                category_id: item.sale_product_category_id,
                bank_id: vm.target_sale_product_bank && vm.target_sale_product_bank.id ?
                    vm.target_sale_product_bank.id : null
            };
            //- 打 ＡＰＩ 拿分支資料
            vm.$store.dispatch("sale_product/show", data).then(() => {
                //- 帶入選擇的分類
                vm.nowSelectItemBranch = {
                    index: index,
                    name: item.sale_product_category_title
                };
            });
        },
        //- 關閉銷售通路 Modal
        closeHandler: function() {
            let vm = this;
            //- 如果已經關閉了就 return
            if (vm.isSalesChannelModalShow === false) return;
            //- 清空銷售通路資料
            vm.salesChannelInfo = null;
            vm.isSalesChannelModalShow = false;
        },
        //- 顯示銷售通路 Modal
        showSalesChannelModalHandler: function(index) {
            let vm = this;
            //- 如果已經打開了就 return
            if (vm.isSalesChannelModalShow === true) return;
            vm.salesChannelInfo = vm.$_.cloneDeep(vm.goodsInfo[index].sales_channel);
            vm.isSalesChannelModalShow = true;
        },
        //- 選擇其他銀行看其他銀行的銷售懶人包內容
        selectOtherBankToGetSaleProductHandler: function(item) {
            let vm = this;
            //- 重置內容
            vm.itemBranch = null;
            vm.nowSelectItemBranch = null;
            vm.nowSelectIndex = null;
            //- 重新設定商品詳細內容
            vm.$store.commit("sale_product/resetGoodsInfo");
            //- 如果有選銀行, 就重打一次 API 拿銀行懶人包內容
            if (item !== null) {
                //- 放入 Object
                let data = {
                    bank_id: item.id
                };
                //- 拿取目標銀行的懶人包內容
                vm.$store.dispatch("sale_product/index", data).then(()=>{
                    //- 設定預設第一層資訊
                    vm.setDefaultInfo();
                });
            } else {
                //- 拿取原本銀行的懶人包內容
                vm.$store.dispatch("sale_product/index").then(()=>{
                    //- 設定預設第一層資訊
                    vm.setDefaultInfo();
                });
            }
        },
        //- 重置選項
        resetSelectOtherBankToGetSaleProductHandler: function() {
            let vm = this;
            //- 重置內容
            vm.itemBranch = null;
            vm.nowSelectItemBranch = null;
            vm.nowSelectIndex = null;
            vm.target_sale_product_bank = null;
            //- 拿取原本銀行的懶人包內容
            vm.$store.dispatch("sale_product/index").then(()=>{
                //- 設定預設第一層資訊
                vm.setDefaultInfo();
            });
        },
        //- 設定預設第一層資訊
        setDefaultInfo: function() {
            let vm = this;
            //- 如果第一層有商品, 就直接帶入第一層商品分類
            if (vm.menu && vm.menu.length > 0) {
                vm.itemBranch = vm.menu[0].sale_product_categories;
                vm.nowSelectIndex = 0;

                let itemBranchTarget = vm.itemBranch[0];

                let data = {
                    category_id: itemBranchTarget.sale_product_category_id,
                    bank_id: vm.target_sale_product_bank && vm.target_sale_product_bank.id ?
                    vm.target_sale_product_bank.id : null
                };
                //- 打 ＡＰＩ 拿分支資料
                vm.$store.dispatch("sale_product/show", data).then(() => {
                    //- 帶入選擇的分類
                    vm.nowSelectItemBranch = {
                        index: "0",
                        name: itemBranchTarget.sale_product_category_title
                    };

                    //- 拿取有銀行列表
                    vm.$store.dispatch("important_message/getMessageBankList").then(() => {
                        //- 手動關閉
                        vm.$Swal.close();
                        //- showRequestLoadingSwal 設定為 true, 讓之後打 API 會顯示提示
                        window.showRequestLoadingSwal = true;
                    });
                });
            } else {
                //- 拿取有銀行列表
                vm.$store.dispatch("important_message/getMessageBankList").then(() => {
                    //- 手動關閉
                    vm.$Swal.close();
                    //- showRequestLoadingSwal 設定為 true, 讓之後打 API 會顯示提示
                    window.showRequestLoadingSwal = true;
                });
            }
        },
    },
    computed: {
        ...mapState({
            memberProfile: state => state.index.memberProfile, //- 會員基本資料
            menu: state => state.sale_product.menu, //- 商品型態分類
            goodsInfo: state => state.sale_product.goodsInfo, //- 商品詳細內容
            messageBankList: state => state.important_message.messageBankList //- 銷售懶人包銀行列表
        })
    }
};